if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.slides = [];
      this.currentIndex = 0;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.lightbox__slide'));
      this.counter = this.querySelector('.lightbox__counter-current');
      this.prevBtn = this.querySelector('.lightbox__nav--prev');
      this.nextBtn = this.querySelector('.lightbox__nav--next');
      
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }
      
      this.addEventListener('keydown', this.handleKeyDown.bind(this));
      
      const overlay = this.querySelector('.lightbox__overlay');
      if (overlay) {
        overlay.addEventListener('click', () => this.hide());
      }
      
      const closeBtn = this.querySelector('.lightbox__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.hide());
      }
    }

    hide() {
      const activeSlide = this.querySelector('.lightbox__slide.is-active');
      const lightboxImage = activeSlide?.querySelector('.lightbox__image');
      
      if (this.openedBy && lightboxImage) {
        const sourceImg = this.openedBy.closest('.gallery__slide')?.querySelector('.gallery__img');
        if (sourceImg) {
          const sourceRect = sourceImg.getBoundingClientRect();
          const lightboxRect = lightboxImage.getBoundingClientRect();
          
          const scaleX = sourceRect.width / lightboxRect.width;
          const scaleY = sourceRect.height / lightboxRect.height;
          const scale = Math.max(scaleX, scaleY);
          
          const translateX = (sourceRect.left + sourceRect.width / 2) - (lightboxRect.left + lightboxRect.width / 2);
          const translateY = (sourceRect.top + sourceRect.height / 2) - (lightboxRect.top + lightboxRect.height / 2);
          
          lightboxImage.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease';
          lightboxImage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
          lightboxImage.style.opacity = '0';
          
          this.querySelector('.lightbox__overlay').style.transition = 'opacity 0.3s ease';
          this.querySelector('.lightbox__overlay').style.opacity = '0';
          
          setTimeout(() => {
            this.removeAttribute('open');
            lightboxImage.style.transform = '';
            lightboxImage.style.opacity = '';
            lightboxImage.style.transition = '';
            this.querySelector('.lightbox__overlay').style.opacity = '';
            this.querySelector('.lightbox__overlay').style.transition = '';
          }, 350);
        } else {
          this.removeAttribute('open');
        }
      } else {
        this.removeAttribute('open');
      }
      
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
      
      if (window.pauseAllMedia) {
        window.pauseAllMedia();
      }
    }

    show(opener) {
      this.openedBy = opener;
      this.showActiveMedia();
      
      const activeSlide = this.querySelector('.lightbox__slide.is-active');
      const lightboxImage = activeSlide?.querySelector('.lightbox__image');
      const sourceImg = opener?.closest('.gallery__slide')?.querySelector('.gallery__img');
      
      if (sourceImg && lightboxImage) {
        this.setAttribute('open', '');
        
        requestAnimationFrame(() => {
          const sourceRect = sourceImg.getBoundingClientRect();
          const lightboxRect = lightboxImage.getBoundingClientRect();
          
          const scaleX = sourceRect.width / lightboxRect.width;
          const scaleY = sourceRect.height / lightboxRect.height;
          const scale = Math.max(scaleX, scaleY);
          
          const translateX = (sourceRect.left + sourceRect.width / 2) - (lightboxRect.left + lightboxRect.width / 2);
          const translateY = (sourceRect.top + sourceRect.height / 2) - (lightboxRect.top + lightboxRect.height / 2);
          
          lightboxImage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
          lightboxImage.style.opacity = '0.5';
          
          requestAnimationFrame(() => {
            lightboxImage.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease';
            lightboxImage.style.transform = 'translate(0, 0) scale(1)';
            lightboxImage.style.opacity = '1';
            
            setTimeout(() => {
              lightboxImage.style.transition = '';
            }, 400);
          });
        });
      } else {
        this.setAttribute('open', '');
      }
      
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('overflow-hidden');
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      if (!mediaId) return;
      
      const targetSlide = this.querySelector(`.lightbox__slide[data-media-id="${mediaId}"]`);
      if (targetSlide) {
        const index = parseInt(targetSlide.dataset.index, 10);
        this.goTo(index);
      }
    }

    goTo(index) {
      if (index < 0 || index >= this.slides.length) return;
      
      this.slides.forEach(slide => slide.classList.remove('is-active'));
      this.slides[index].classList.add('is-active');
      this.currentIndex = index;
      
      if (this.counter) {
        this.counter.textContent = index + 1;
      }
    }

    prev() {
      const newIndex = this.currentIndex <= 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goTo(newIndex);
    }

    next() {
      const newIndex = this.currentIndex >= this.slides.length - 1 ? 0 : this.currentIndex + 1;
      this.goTo(newIndex);
    }

    handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.hide();
      } else if (e.key === 'ArrowLeft') {
        this.prev();
      } else if (e.key === 'ArrowRight') {
        this.next();
      }
    }
  });
}
